// extracted by mini-css-extract-plugin
export default {"header":"PacienteAntecedentes_header__0Ilpe","subHeader":"PacienteAntecedentes_subHeader__rQdrc","data":"PacienteAntecedentes_data__jUVPR"};